import { Box } from "@mui/material";
import downloadjs from "downloadjs";
import * as React from "react";
import { IReportGenerated2 } from "source/models/report/reportGenerated2";
import { IReportItem } from "source/models/report/reportItem";
import { Base } from "ui/Scripts/source/framework/base";
import { downloadMimeType } from "ui/Scripts/source/models/consts";
import { ReportType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { DownloadButton } from "../../Button/DownloadButton/DownloadButton";
import { PageTitle } from "../../Page/PageTitle";
import { ReportExcelReport } from "../../Report/ReportExcelReport";
import { ReportPdfReport } from "../../Report/ReportPdfReport";
import { ReportContainer } from "../../ReportContainer";

export interface IPageReportProps {
    isLoading: boolean;
    htmlReport?: React.ReactNode;
    hidePageTitle?: boolean;
    report: IReportItem;
    reportGenerated: IReportGenerated2;
    reportDataUri: string;
    sortingDisabled?: boolean;
    multiSelect?: boolean;
    selectedId?: string;
    checkedIds?: string[];
    onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
    onSetSelectedIds?: (selectedId: string, checkedIds: string[]) => void;
    onDownload?: () => void;
}

export const PageReport = (props: IPageReportProps) => {
    const handleDownload = () => {
        if (!props.reportGenerated || !props.reportGenerated.content) return;
        const blob = Base.base64ToBlob(props.reportGenerated.content, downloadMimeType);
        if (!blob) return;
        downloadjs(blob, props.reportGenerated.fileName);
    };

    const reportIsHtmlReport = !!props.report && props.report.type === ReportType.Html;
    const reportIsNotHtmlReport = !!props.report && props.report.type !== ReportType.Html;

    return (
        <Box display="flex" flexDirection="column" flexGrow={1} position="relative" width={"calc(100% - 436px)"}>
            {!props.hidePageTitle && (
                <PageTitle title={Translations.Reports + (props.report ? " - " + props.report.title : "")} position="absolute">
                    {reportIsNotHtmlReport &&
                        <DownloadButton onClick={props.onDownload || handleDownload} disabled={!props.reportGenerated || props.isLoading}>
                            {props.report.type === ReportType.Pdf ? Translations.DownloadPdf : Translations.ExportToExcel}
                        </DownloadButton>
                    }
                </PageTitle>
            )}
            {reportIsNotHtmlReport &&
                <ReportContainer variant="document">
                    {(!!props.reportGenerated && props.report.type === ReportType.Pdf) &&
                        <ReportPdfReport reportDataUri={props.reportDataUri} />
                    }
                    {(!!props.reportGenerated && props.report.type === ReportType.Excel) &&
                        <ReportExcelReport
                            reportData={props.reportGenerated}
                            sortingDisabled={props.sortingDisabled}
                            sortColumn={props.report.sortColumn}
                            sortOrderIsAsc={props.report.sortOrderIsAsc}
                            multiSelect={props.multiSelect}
                            selectedId={props.multiSelect ? props.selectedId : ""}
                            checkedIds={props.multiSelect ? props.checkedIds : []}
                            onSetSortData={props.onSetSortData}
                            onSetSelectedIds={props.multiSelect ? props.onSetSelectedIds : null}
                        />
                    }
                </ReportContainer>
            }
            {(reportIsHtmlReport && props.htmlReport) &&
                (props.htmlReport)
            }
        </Box>
    );
};